import axios from "axios";

const onecodeAPI = axios.create({
  // baseURL: "https://0a62-106-51-88-97.in.ngrok.io",
  baseURL: "https://api.zetapp.in",
  // baseURL: "https://l.bnking.in",
  timeout: 5 * 60 * 1000,
});

const sbiAPI = axios.create({
  // baseURL: "https://0a62-106-51-88-97.in.ngrok.io",
  // baseURL: "https://api.zetapp.in",
  baseURL: "https://l.bnking.in",
  timeout: 5 * 60 * 1000,
});



export { onecodeAPI , sbiAPI };
